import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { LanguageService } from '../../../core/services/language.service';

import { FeaturedTestimoniesSliderStoreService } from './featured-testimonies-slider.component-store';
import { filter, take } from 'rxjs';
import { SliderComponent } from '../slider/slider.component';
import Swiper from 'swiper/bundle';
import { createSwiperOptions } from '../../utils/swiper.utils';

@Component({
  selector: 'app-featured-testimonies-slider',
  templateUrl: './featured-testimonies-slider.component.html',
  styleUrls: ['./featured-testimonies-slider.component.scss'],
  providers: [FeaturedTestimoniesSliderStoreService],
})
export class FeaturedTestimoniesSliderComponent implements OnInit {
  swiper: Swiper;
  @ViewChild('swiper') swiperRef: ElementRef;

  constructor(public componentStore: FeaturedTestimoniesSliderStoreService) {}

  ngOnInit() {
    this.componentStore.initList({});
    this.componentStore.loaded$
      .pipe(
        filter((loaded) => loaded),
        take(1)
      )
      .subscribe(() => {
        setTimeout(() => {
          this.swiper = new Swiper(
            this.swiperRef.nativeElement,
            createSwiperOptions('featuredTestimonies')
          );
        });
      });
  }
}
